import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import useIngredients from '../features/IngredientContainer/hooks/useIngredients';
import useExcludeIngredients from '../features/IngredientContainer/hooks/useExcludeIngredients';
import Columns from '../features/IngredientContainer/columns';
import Table from '../components/Table/Table';
import { toJS } from '../utils/immutableUtils';
import { FormattedMessage } from 'react-intl';
import ButtonGroup from '../components/common/ButtonGroup';
import { getIsGlobalUser } from '../features/loginSystem/selectors';
import Button from '../components/common/Button';
import View from './views';
import PaperContainer from '../components/common/PaperContainer';
import usePpis from '../features/PpiContainer/hooks/usePpis';
import useGlobalPpis from '../features/PpiContainer/hooks/useGlobalPpis';
import { EnrichmentData, States } from '../features/PpiContainer/constants';
import {
  ppiCreateFromExistingRoute,
  ppiCreateRoute,
  ppiCreateFromPublishedPpiRoute
} from '../routes';
import ProgressFullscreen from 'components/common/ProgressFullscreen';
import { getLanguage } from 'features/app/selectors';
import { element } from 'prop-types';
import { has } from 'lodash';
import { fetchNewPPIAvilableData } from 'features/PpiContainer/actions';
import { getNewPpiAvailabelData } from 'features/PpiContainer/selectors';

function excludePpis(ppis, ppisToExclude) {
  const excludeItemCodes = ppisToExclude.map(localPpi => localPpi.itemCode);
  return ppis.filter(ppi => {
    return !excludeItemCodes.includes(ppi.itemCode);
  });
}

const removeDuplicates = array => {
  const seen = new Set();
  return array.filter(item => {
    if (seen.has(item.id)) {
      return false; // Skip if `id` is already in the set
    }
    seen.add(item.id); // Add `id` to the set
    return true;
  });
};

function includePpis(ppis, ppisToExclude) {
  // (global, local)
  // const excludeItemCodes = ppis.map(localPpi => localPpi.itemCode);
  // const excludeItem= ppis.map(localPpi => localPpi.id);
  //   let g =[];
  // const p = ppisToExclude.map(item=>
  //   { if(item.inProgressPPIEnrichmentData){
  //     return item.inProgressPPIEnrichmentData.parentPpiId;
  //   } });
  //   const globalitemcode = ppis.filter(item=>ppisToExclude.map(o=>o.relationshipId)===(item.itemCode));
  //   p.filter(pt=>{
  //     if(!pt==(globalitemcode.map(a=>a.id))){
  //       console.log('pt',pt);
  //       const gto = globalitemcode.filter(t=>t.id==pt);
  //       console.log('t',gto);
  //       g.push({...gto})

  //      }
  //   })
  const dto = [];
  const code = [];
  ppisToExclude.filter(ppi => {
    const globalitemcode = ppis.filter(
      item => item.itemCode === ppi.relationshipId
    );

    if (globalitemcode.length) {
      globalitemcode.forEach(gt => {
        if (
          (ppi.inProgressPPIEnrichmentData &&
            ppi.inProgressPPIEnrichmentData.parentPpiId &&
            gt.id !== ppi.inProgressPPIEnrichmentData.parentPpiId) ||
          (ppi.publishedPPIEnrichmentData &&
            ppi.publishedPPIEnrichmentData.parentPpiId &&
            gt.id !== ppi.publishedPPIEnrichmentData.parentPpiId)
        ) {
          // code.push({...gt});
          dto.push({ ...gt });
          // }else {
          //   dto.push({...gt});
          // }
        }
      });
    }
  });

  const o = dto.filter(
    a =>
      !ppisToExclude
        .map(a => {
          if (
            has(a, 'inProgressPPIEnrichmentData') &&
            a.inProgressPPIEnrichmentData
          ) {
            return a.inProgressPPIEnrichmentData.parentPpiId;
          }
          return a.publishedPPIEnrichmentData.parentPpiId;
        })
        .includes(a.id)
  );

  // const ppp = removeDuplicates(o);

  return removeDuplicates(dto);

  // return dto.filter(i=>ppisToExclude.map(p=>p.inProgressPPIEnrichmentData &&
  //   !p.inProgressPPIEnrichmentData.parentPpiId).includes(i.id));
}

// function includeNewPpiUpdateData(updatesData, localPpiData, globalData) {
//   // const update = updatesData.map(a => a.relationshipId);
//   // const fillteredUpdate = localPpiData
//   //   .filter(
//   //     a =>
//   //       update.includes(a.relationshipId) &&
//   //       ((a.inProgressPPIEnrichmentData &&
//   //         a.inProgressPPIEnrichmentData.parentPpiId) ||
//   //         (a.publishedPPIEnrichmentData &&
//   //           a.publishedPPIEnrichmentData.parentPpiId))
//   //   )
//   //   .map(a => a.relationshipId);
//   // return updatesData.filter(a => !fillteredUpdate.includes(a.relationshipId));
//   return localPpiData.filter(local=>{
//     if( updatesData.filter(update=>update.itemCode === local.itemCode && update.relationshipId === local.relationshipId).length){
//         return local
//     }

// })
// }

function includeNewPpiUpdateData(updatesData, localPpiData, globalData) {
  const globalUpdateData = globalData.filter(itm => {
    if (
      updatesData.filter(
        a => a.relationshipId === itm.itemCode && itm.status === 'PUBLISHED'
      ).length
    ) {
      return itm;
    }
  });

  const localfilter = localPpiData.filter(local => {
    if (
      updatesData.filter(
        update =>
          update.itemCode === local.itemCode &&
          update.relationshipId === local.relationshipId
      ).length
    ) {
      return local;
    }
  });

  const groupedByItemCode = localfilter.reduce((acc, item) => {
    if (!acc[item.itemCode]) acc[item.itemCode] = [];
    acc[item.itemCode].push(item);
    return acc;
  }, {});

  const grouped = groupedByItemCode;

  for (const itemCode in groupedByItemCode) {
    const group = groupedByItemCode[itemCode];
    const globalids = globalUpdateData.map(a => a.id);
    const hasParent = group.some(obj =>
      globalids.includes(
        (obj.inProgressPPIEnrichmentData &&
          obj.inProgressPPIEnrichmentData.parentPpiId) ||
          (obj.publishedPPIEnrichmentData &&
            obj.publishedPPIEnrichmentData.parentPpiId)
      )
    );
    if (hasParent) {
      delete grouped[itemCode];
    }
  }
  return Object.values(groupedByItemCode).flat();
}

const formatFormulaCode = formulaCode => {
  return (
    formulaCode &&
    `${formulaCode.substring(0, 3)} ${formulaCode.substring(
      3,
      7
    )} ${formulaCode.substring(7, formulaCode.length)}`
  );
};

const formatDate = formulaCode => {
  return formulaCode && formulaCode.substring(0, 10);
};

const NewIngredientsView = () => {
  const [isFetchingGlobal, globalPpisRaw] = useGlobalPpis({
    status: States.PUBLISHED
  });
  const [isFetchingLocal, localPpisRaw] = usePpis();
  const [isFetching, ingredientsRaw, allRawIngredients] = useIngredients({
    hasPpi: false
  });
  const ingredients = toJS(ingredientsRaw, []);
  const allIngredients = toJS(allRawIngredients, []);
  const [excludeIngredients] = useExcludeIngredients();
  const globalPpis = toJS(globalPpisRaw, []);
  const localPpis = toJS(localPpisRaw, []);
  const isGlobalUser = useSelector(getIsGlobalUser);
  const language = useSelector(getLanguage);
  const dispatch = useDispatch();
  const newPpiAvailabelDataRaw = useSelector(getNewPpiAvailabelData);
  const newPpiAvailabelData = toJS(newPpiAvailabelDataRaw);
  // const globalPpi = localPpis.filter(itm => {
  //   if (globalPpis.map(item=>item.itemCode)===(itm.relationshipId)){
  //     if((itm.publishedPPIEnrichmentData &&
  //       !globalPpis.map(item=>item.id)===(itm.publishedPPIEnrichmentData.parentPpiId))||
  //       (itm.inProgressPPIEnrichmentData &&
  //         !globalPpis.map(item=>item.id)===(itm.inProgressPPIEnrichmentData.parentPpiId))){
  //       return itm;
  //     }
  //   }
  // });
  useEffect(() => {
    if (!isGlobalUser) {
      dispatch(fetchNewPPIAvilableData());
    }
  }, []);
  const globalPpi = includePpis(globalPpis, localPpis);

  const local = localPpis.filter(item => {
    if (item.ppiItemCode !== null) {
      return item;
    }
  });

  const global = globalPpis.filter(item => {
    if (item.itemCode !== null) {
      return item;
    }
  });

  // const filterglobal = globalPpi.filter(item=>item.itemCode);
  // const addglobal =
  // ingredients.filter(itm=>filterglobal.includes(itm.itemCode));

  // console.log('globalppi',globalPpi);
  const globalPpisWithoutLocalPpi = excludePpis(globalPpis, localPpis);

  //const globalPpisLocalPpi   = includePpis(globalPpis, localPpis);
  function getLatestPublishedItem(data) {
    if (!Array.isArray(data) || data.length === 0) return null;

    return data.reduce((latest, current) => {
      const latestDate = new Date(
        latest.publishedPPIEnrichmentData.actualPublishedDate
      );
      const currentDate = new Date(
        current.publishedPPIEnrichmentData.actualPublishedDate
      );
      return currentDate < latestDate ? current : latest;
    });
  }

  const ss = [];
  const gp = globalPpi.filter(e => e.status === 'PUBLISHED');
  const fiData = allIngredients.filter(a =>
    gp.map(a => a.itemCode).includes(a.relationshipId)
  );
  const filter = fiData.filter(i =>
    localPpis.map(local => local.itemCode).includes(i.itemCode)
  );

  const relationShipIds = allIngredients.map(a => a.relationshipId);
  const recordsBeforeImportRaw = localPpis.filter(
    a =>
      relationShipIds.includes(a.relationshipId) &&
      ((a.inProgressPPIEnrichmentData &&
        a.inProgressPPIEnrichmentData.parentPpiId === null) ||
        (a.publishedPPIEnrichmentData &&
          a.publishedPPIEnrichmentData.parentPpiId === null))
  );

  let array = [];
  filter.forEach(element => {
    gp.forEach(global => {
      if (element.relationshipId == global.itemCode) {
        array.push({
          ...global,
          ppiItemCode: element.itemCode,
          presentationName: element.presentationName
          //  ...element.presentationName = global.presentationName
        });
      }
    });
  });

  // Below logic written to handle display PRF's when FRF have multiple PRF's mapped (IFPPSI-1936)
  let newArry_1936 = [];
  filter.forEach(itm => {
    const locUsedData = localPpis
      .filter(a => a.itemCode === itm.itemCode)
      .map(
        element =>
          (element.inProgressPPIEnrichmentData &&
            element.inProgressPPIEnrichmentData.parentPpiId) ||
          (element.publishedPPIEnrichmentData &&
            element.publishedPPIEnrichmentData.parentPpiId)
      )
      .filter(a => a);

    array.forEach(element => {
      if (
        element.ppiItemCode === itm.itemCode &&
        !locUsedData.includes(element.id)
      ) {
        newArry_1936.push(element);
      }
    });
  });

  // Below logic written for handle if ppi have New PPI Available update
  let arr_2338 = [];
  if (newPpiAvailabelData.length && localPpis.length) {
    const updateIds = includeNewPpiUpdateData(
      newPpiAvailabelData,
      localPpis,
      globalPpis
    ).map(a => a.itemCode);
    const UpdateIngredients = allIngredients.filter(a =>
      updateIds.includes(a.itemCode)
    );
    // const UpdateIngredients = includeNewPpiUpdateData(newPpiAvailabelData, localPpis)
    UpdateIngredients.forEach(element => {
      let globalSortedData = globalPpis.filter(
        a => a.itemCode === element.relationshipId
      );
      let sortedData = getLatestPublishedItem(globalSortedData);
      // globalPpis.forEach(global => {

      if (sortedData && element.relationshipId === sortedData.itemCode) {
        arr_2338.push({
          ...sortedData,
          ppiItemCode: element.itemCode,
          presentationName: element.presentationName
          //  ...element.presentationName = global.presentationName
        });
      }
      // });
    });
  }

  // const sample = removeDuplicates(ss);
  // });

  let globalPpisWithPPIItemCode = globalPpisWithoutLocalPpi;
  const localPpiCopy = 'true';

  if (isFetching || isFetchingGlobal) {
    return <ProgressFullscreen open />;
  }

  // if (ingredients.length > 0 && globalPpi.length > 0) {
  //   for (var i = 0; i < globalPpi.length; i++) {
  //     const filteredList = ingredients.filter(item => {
  //       return item.relationshipId === globalPpi[i].itemCode;
  //     });
  //     if (filteredList.length > 0) {
  //       globalPpi[i].ppiItemCode = filteredList[0].itemCode;
  //       globalPpi[i].presentationName =
  //         filteredList[0].presentationName;
  //     } else {
  //       globalPpi[i].ppiItemCode = null;
  //       globalPpi[i].presentationName = null;
  //     }
  //   }
  // }

  if (ingredients.length > 0 && globalPpisWithoutLocalPpi.length > 0) {
    for (var i = 0; i < globalPpisWithoutLocalPpi.length; i++) {
      const filteredList = ingredients.filter(item => {
        return item.relationshipId === globalPpisWithoutLocalPpi[i].itemCode;
      });
      if (filteredList.length > 0) {
        globalPpisWithoutLocalPpi[i].ppiItemCode = filteredList[0].itemCode;
        globalPpisWithoutLocalPpi[i].presentationName =
          filteredList[0].presentationName;
      } else {
        globalPpisWithoutLocalPpi[i].ppiItemCode = null;
        globalPpisWithoutLocalPpi[i].presentationName = null;
      }
    }
  }

  globalPpisWithPPIItemCode = globalPpisWithoutLocalPpi.filter(item => {
    if (item.ppiItemCode !== null) {
      return item;
    }
  });

  const GlobalPpiItemCode =
    globalPpisWithPPIItemCode &&
    globalPpisWithPPIItemCode.map(i => i.ppiItemCode);

  const ingredientsWithoutGlobalppi =
    ingredients &&
    ingredients.filter(i => !GlobalPpiItemCode.includes(i.itemCode));

  const ingredientsData = [
    ...globalPpisWithPPIItemCode,
    ...ingredientsWithoutGlobalppi,
    ...newArry_1936,
    ...arr_2338
  ];

  View.NewIngredientsView.visit();

  function clickExcludeIngredients(selectedData, callback) {
    const itemCodes = selectedData.map(row =>
      row.data.ppiItemCode !== undefined
        ? row.data.ppiItemCode
        : row.data.itemCode
    );
    excludeIngredients(itemCodes);
    callback();
  }

  const UpdatesColumns = {
    MarketFoodID: {
      name: 'ppiItemCode',
      label: 'iFood ID',
      calculateCellValue: rowData => {
        return rowData.ppiItemCode === undefined
          ? formatFormulaCode(rowData.itemCode)
          : formatFormulaCode(rowData.ppiItemCode);
      },
      filterable: false,
      sortable: false,
      searchable: true,
      width: 140,
      grow: 0,
      shrink: 0
    },
    IFoodID: {
      name: 'iFoodID',
      label: 'Global iFood ID',
      calculateCellValue: rowData => {
        return rowData.ppiItemCode === undefined
          ? null
          : formatFormulaCode(rowData.relationshipId);
      },
      filterable: false,
      sortable: true,
      searchable: true,
      width: 140,
      grow: 0,
      shrink: 0
    },
    PresentationName: {
      name: 'presentationName',
      label: 'Product Name',
      dataField: 'presentationName',
      calculateCellValue: rowData => {
        return rowData.presentationName && rowData.presentationName[language];
        // return rowData.ppiItemCode === undefined
        //   ? rowData.presentationName[language]
        //   : rowData.publishedPPIEnrichmentData.info['EN-IF'].presentationName;
      },
      filterable: false,
      sortable: true
      // width: isGlobalUser ? 480 : 220
      // width:  480,
      // grow: 0,
      // shrink: 0
    },
    GlobalPPIName: {
      name: 'ppiName',
      label: 'Global PPI Name',
      dataField: 'presentationName',
      calculateCellValue: rowData => {
        return rowData.publishedPPIEnrichmentData &&
          rowData.publishedPPIEnrichmentData.info &&
          rowData.publishedPPIEnrichmentData
          ? rowData.publishedPPIEnrichmentData.info['EN-IF'].presentationName
          : '';
        // return rowData.ppiItemCode === undefined
        //   ? rowData.presentationName[language]
        //   : rowData.publishedPPIEnrichmentData.info['EN-IF'].presentationName;
      },
      filterable: false,
      sortable: true
      // width: 260,
      // grow: 0,
      // shrink: 0
    },
    ModifyDate: {
      name: 'modifyDates',
      label: 'Modify Date',
      calculateCellValue: rowData => {
        return rowData.ppiItemCode && rowData.ppiItemCode
          ? formatDate(rowData.publishedPPIEnrichmentData.modifyDate)
          : formatDate(rowData.modifyDate);
      },
      // dataType: DataTypes.Date,
      filterable: false,
      sortable: true,
      searchable: false,
      width: 150,
      grow: 0,
      shrink: 0
    },
    CreateAndCopyPpi: {
      name: 'createAndCopyPpi',
      label: '',
      calculateCellValue: rowData => {
        if (rowData.ppiItemCode !== undefined) {
          const copyRoute = ppiCreateFromExistingRoute(
            rowData.id,
            rowData.publishedPPIEnrichmentData.id,
            rowData.ppiItemCode === null
              ? rowData.itemCode
              : rowData.ppiItemCode
          );
          return (
            <ButtonGroup
              route={copyRoute}
              menuItems={[
                {
                  text: <FormattedMessage id="ppi.copyLocalInstruction" />,
                  route: ppiCreateFromPublishedPpiRoute(
                    rowData.ppiItemCode === null
                      ? rowData.itemCode
                      : rowData.ppiItemCode,
                    localPpiCopy
                  )
                },
                {
                  text: <FormattedMessage id="ppi.createInstruction" />,
                  route: ppiCreateRoute(
                    rowData.ppiItemCode === null
                      ? rowData.itemCode
                      : rowData.ppiItemCode
                  )
                }
              ]}
            >
              <FormattedMessage id="ppi.copyGlobalInstruction" />
            </ButtonGroup>
          );
        }
        return (
          <ButtonGroup
            route={ppiCreateRoute(rowData.itemCode)}
            menuItems={[
              {
                text: <FormattedMessage id="ppi.copyLocalInstruction" />,
                route: ppiCreateFromPublishedPpiRoute(
                  rowData.itemCode,
                  localPpiCopy
                )
              }
            ]}
          >
            <FormattedMessage id="ppi.createInstruction" />
          </ButtonGroup>
        );
      },
      filterable: false,
      sortable: false,
      searchable: false,
      width: 240,
      grow: 0,
      shrink: 0
    }
  };

  return (
    <PaperContainer>
      <Table
        title="ingredient.newIngredientsTableTitle"
        data={ingredients.length > 0 ? ingredientsData : []}
        columns={
          !isGlobalUser
            ? [
                UpdatesColumns.MarketFoodID,
                UpdatesColumns.IFoodID,
                UpdatesColumns.GlobalPPIName,
                UpdatesColumns.PresentationName,
                UpdatesColumns.ModifyDate,
                UpdatesColumns.CreateAndCopyPpi
              ]
            : [
                UpdatesColumns.MarketFoodID,
                UpdatesColumns.PresentationName,
                Columns.ModifyDate,
                UpdatesColumns.CreateAndCopyPpi
              ]
        }
        getObjectId={object => object.id}
        defaultSorting={[{ columnName: 'presentationName', direction: 'asc' }]}
        selectable
        showLanguageSelector={false}
        actions={[
          {
            label: 'Exclude',
            onClick: clickExcludeIngredients
          }
        ]}
      />
    </PaperContainer>
  );
};

export default NewIngredientsView;
